import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  EditButton,
  Filter,
  ReferenceInput,
  SelectInput,
  ChipField,
  ReferenceArrayInput,
  SelectArrayInput,
  DateField,
  DateInput,
  TextInput,
  SelectField
} from "react-admin";
import { SUPERADMIN } from "../../constant/TypeRole";
import { typeRepair } from "../../constant/TypeRepair";
import Actions from '../Actions'

export const SaleAgencyList = props => {
  // const role = localStorage.getItem('role')
  // const project = JSON.parse(localStorage.getItem('project'))
  // const filter = role ? role === SUPERADMIN ? {} : { project } : { project }
  return (
    <List
      title="saleagency.saleagency"
      bulkActions={false}
      actions={<Actions create />}
      {...props}
    // bulkActions={false}
    // filters={<RepairFilter />}
    // sort={{ field: 'createdAt', order: 'DESC' }}
    // filterDefaultValues={filter}
    >
      <Datagrid>
        <div />
        <TextField source="name" />
        <EditButton />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/components/saleagency/SaleAgencyList.js